import './ChildAppInstallBtn.scss'

import { duration } from '@eturi/date-util'
import { useBoolState, useFn, useTimeout } from '@eturi/react'
import { useT } from '@eturi/react-i18next'
import { installChildApp } from '@op/services'
import { disabledProps } from '../../common'
import { commons } from '../../ghetto-commons'
import { useAppDispatch } from '../../types'
import { Btn, InfoModal, useToasts } from '../../widgets'

type ChildAppInstallBtnProps = {
	readonly childId: string
	readonly className?: string
	readonly deviceId: string
	readonly disabled?: boolean
}

export const ChildAppInstallBtn = ({
	childId,
	deviceId,
	disabled = false,
}: ChildAppInstallBtnProps) => {
	const d = useAppDispatch()
	const [t] = useT()
	const { addErrorToast } = useToasts()
	const [isChildAppInstallModalVisible, showChildAppInstallModal, hideChildAppInstallModal] =
		useBoolState(false)
	const [isInstallingChildApp, setInstallingChildApp, setNotInstallingChildApp] =
		useBoolState(false)
	const [setInstallingTimeout, clearInstallingTimeout] = useTimeout()

	const isInstallChildAppDisabled = disabled || isInstallingChildApp

	const handleInstallChildAppClick = useFn(async () => {
		const CHILD_APP_INSTALL_TIMEOUT = duration(45, 's')

		setInstallingChildApp()
		setInstallingTimeout(setNotInstallingChildApp, CHILD_APP_INSTALL_TIMEOUT)

		try {
			await d(installChildApp({ deviceId, userId: childId })).unwrap()
			showChildAppInstallModal()
		} catch {
			addErrorToast(t('error_strings.install_child_app_error'))
			clearInstallingTimeout()
			setNotInstallingChildApp()
		}
	})

	return (
		<>
			<Btn
				{...disabledProps(isInstallChildAppDisabled, 'install-child-app-btn has-img font-bold')}
				onClick={handleInstallChildAppClick}
			>
				<span>
					{t('actions.install_child_app')}
					<img src={commons.OPJ_LOGO_MANGLE$$} alt="OurPact Jr." title="OurPact Jr." />
				</span>
			</Btn>

			{isChildAppInstallModalVisible && (
				<InfoModal
					header={t('devices.child_app_installed_modal.header')}
					onClose={hideChildAppInstallModal}
				>
					<p>{t('devices.child_app_installed_modal.description')}</p>

					<InfoModal.Footer>
						<Btn onClick={hideChildAppInstallModal}>{t('actions.ok')}</Btn>
					</InfoModal.Footer>
				</InfoModal>
			)}
		</>
	)
}
